import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';

import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';

import { MatTableDataSource } from '@angular/material/table';

import { MatDialog } from '@angular/material/dialog';

import { MatSnackBar } from '@angular/material/snack-bar';

import { Wage } from '../model/wage.model';

import { ApiService } from '../services/api.service';

import { WageeditComponent } from '../wageedit/wageedit.component';

import { WageAuditDialogComponent } from '../wage-audit-dialog/wage-audit-dialog.component';

@Component({

  selector: 'app-wagedetails',

  templateUrl: './wagedetails.component.html',

  styleUrls: ['./wagedetails.component.scss']

})

export class WagedetailsComponent implements OnInit, AfterViewInit {

  displayedColumns = ['wageId','employeeId', 'employeeName', 'employeeDepartment','salaryAmount','guno','bonus','expId', 'paymentDate', 'paymentMode', 'empLoan', 

    'penalty','netSalary', 'remarks','createdBy','createdName', 'actions'];

  optionList = [

    { key: 1, name: 'Wage ID' },

    { key: 2, name: 'Employee ID' },

    { key: 3, name: 'Expense ID' },

    { key: 4, name: 'Search B/w Payment Dates' }

  ];

  enableButton = false;

  selectedOption = 0;

  searchValue = '';

  totalData: number;

  pageSizes = [10, 25, 50];

  isLoading = false;

  searchTriggered = false;

  dataSource = new MatTableDataSource<Wage>(null);

  startDate :any;

  endDate:any;

  maxDate: string;

  isDateInvalid: boolean = true;

  showError: boolean = false;

  wages =[];

  // Month-based wage operations
  selectedMonthYear: string;
  isMonthFilterActive: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  employees: any;

  loggedUserName: any;

  loggedInUserId: any;

  constructor(private apiService: ApiService, private dialog: MatDialog,

     private _snackBar: MatSnackBar

  ) {}

  ngOnInit(): void {

    const today = new Date();

    this.maxDate = today.toISOString().split('T')[0];

    // Initialise logged in user details for audit / wage generation
    this.apiService.getEmplyees().subscribe(data => {
      this.employees = data.employees;

      const loggedInUser = Number(window.localStorage.getItem('loggedInUser'));
      this.loggedInUserId = loggedInUser;

      const loggedInUserDetail = this.employees.find(emp => emp.employeeId === loggedInUser);
      this.loggedUserName = loggedInUserDetail?.employeeName || '';
    });

  }

  ngAfterViewInit() { 

    this.isLoading = true;

    this.apiService.getWages(

      0,

      10,

      this.selectedOption,

      this.searchValue

    )

    .subscribe(wageData => {

      this.totalData = wageData.totalItems;

      this.dataSource = new MatTableDataSource<Wage>(wageData.wages);

      this.wages = wageData.wages;

      this.isLoading = false;

    });

  }

  validateDates(): void {

    if (this.startDate && this.endDate) {

      this.isDateInvalid = new Date(this.startDate) > new Date(this.endDate);

      this.showError = this.isDateInvalid; 

    } else {

      this.isDateInvalid = true; 

      this.showError = false; 

    }

  }

  validateSearch() {

    if (this.searchValue.trim() && (this.selectedOption === 1 || this.selectedOption === 2 || this.selectedOption === 3)) {

      this.enableButton = true;

    } else {

      this.enableButton = false;

    }

  }

  getWageData() {

    this.isLoading = true;

    this.apiService.getWages(0, 10, this.selectedOption, this.searchValue)

      .subscribe(data => {

        this.totalData = data.totalItems;

        this.dataSource = new MatTableDataSource<Wage>(data.wages);

        this.wages = data.wages;

        this.isLoading = false;

      });

  }

  nextPage(event: PageEvent) {

    this.isLoading = true;

    if(this.selectedOption === 4){

         this.apiService.getAllWagesBasedonDate(this.startDate,this.endDate,event.pageIndex, event.pageSize)

          .subscribe(data => {

            this.isLoading = false;

            this.dataSource = new MatTableDataSource<Wage>(data.wages);

            this.wages = data.wages;

            this.dataSource.paginator = this.paginator;

            this.totalData = data.totalItems;

            this.dataSource.sort = this.sort;

      });

    }else{

       this.apiService.getWages(event.pageIndex, event.pageSize, this.selectedOption, this.searchValue)

        .subscribe(data => {

          this.totalData = data.totalItems;

          this.dataSource = new MatTableDataSource<Wage>(data.wages);

          this.wages = data.wages;

          this.isLoading = false;

        });

    }

  }

  fetchWages(){

    if(!this.isDateInvalid){

      this.isLoading = true;

      this.apiService.getAllWagesBasedonDate(this.startDate,this.endDate,0,10)

          .subscribe(data => {

            this.isLoading = false;

            this.dataSource = new MatTableDataSource<Wage>(data.wages);

            this.wages = data.wages;

            this.dataSource.paginator = this.paginator;

            this.totalData = data.totalItems;

            this.dataSource.sort = this.sort;

      });

    }

    else{

        console.log('Cannot fetch bills. Date range is invalid.');

    }

  }

  generateExpense(){

    this.apiService.generateExpense(this.wages)

      .subscribe(data => {

        if(data.status == "SUCCESS"){

          this._snackBar.open('Expenses Generated Successfully', 'Close', {

            duration: 3000,

          });

        }else if(data.status == "PARTIAL_SUCCESS"){

          this._snackBar.open('Partial Expenses Generated Successfully', 'Close', {

            duration: 3000,

          });

        }else{

          this._snackBar.open('Error While Generating Expenses. Please Try Again After Some Time', 'Close', {

            duration: 3000,

          });

        }

    });

  }

  openEditDialog(wage: any): void {

    const dialogRef = this.dialog.open(WageeditComponent, {

      width: '700px',

      data: { wage }

    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === 'updated') {

        this.getWageData();

      }

    });

  }

  openAuditDialog(wage: any): void {

    const dialogRef = this.dialog.open(WageAuditDialogComponent, {

      width: '90vw',

      maxWidth: '95vw',

      data: { wageId: wage.wageId }

    });

    dialogRef.afterClosed().subscribe(_ => {});

  }

  hasGunoRecords(): boolean {

    return this.dataSource?.data?.some(wage => wage.guno > 0);

  }

  generateGunoForAll() {

    const gunoRecords = this.dataSource.data.filter(wage => wage.guno > 0);

    if (gunoRecords.length === 0) {

      this._snackBar.open('No records with Guno > 0 found.', 'Close', { duration: 3000 });

      return;

    }

    this.apiService.generateGuno(gunoRecords)

      .subscribe(data => {

        if(data.status == "SUCCESS"){

          this._snackBar.open('Expenses for Guno Generated Successfully', 'Close', {

            duration: 3000,

          });

        }else if(data.status == "PARTIAL_SUCCESS"){

          this._snackBar.open('Partial Expenses for Guno Generated Successfully', 'Close', {

});

}else{

this._snackBar.open('Error While Generating Expenses for Guno. Please Try Again After Some Time', 'Close', {

duration: 3000,

});

}

});

}

// =====================
// Month-based operations
// =====================
loadWagesForSelectedMonth(): void {

if (!this.selectedMonthYear) {

this._snackBar.open('Please select a month first.', 'Close', {

duration: 3000

});

return;

}

this.isLoading = true;

this.apiService

.getWagesByMonth(this.selectedMonthYear, 0, 10)

.subscribe(

data => {

this.totalData = data.totalItems;

this.dataSource = new MatTableDataSource<Wage>(data.wages);

this.wages = data.wages;

this.isLoading = false;

this.isMonthFilterActive = true;

},

_ => {

this.isLoading = false;

this._snackBar.open(

'Failed to load wages for selected month.',

'Close',

{ duration: 3000 }

);

}

);

}

rerunSelectedMonth(): void {

if (!this.selectedMonthYear) {

this._snackBar.open('Please select a month first.', 'Close', {

duration: 3000

});

return;

}

const confirmRerun = confirm(

`This will re-generate wages for ${this.selectedMonthYear}. Continue?`

);

if (!confirmRerun) {

return;

}

const payload: any = {

monthYear: this.selectedMonthYear,

loggedId: this.loggedInUserId,

loggedUserName: this.loggedUserName

};

this.apiService.generateWagesForAllEmployees(payload).subscribe(

_ => {

this._snackBar.open(

'Wages re-generated for selected month.',

'Close',

{ duration: 3000 }

);

this.loadWagesForSelectedMonth();

},

error => {

const msg =

(error && error.error && error.error.message) ||

'Error while re-running wages for selected month.';

this._snackBar.open(msg, 'Close', { duration: 3000 });

}

);

}

finalizeSelectedMonth(): void {

if (!this.selectedMonthYear) {

this._snackBar.open('Please select a month first.', 'Close', {

duration: 3000

});

return;

}

const confirmFinalize = confirm(

`This will finalize wages for ${this.selectedMonthYear}. You will not be able to edit them afterwards. Continue?`

);

if (!confirmFinalize) {

return;

}

this.apiService.finalizeWagesForMonth(this.selectedMonthYear).subscribe(

_ => {

this._snackBar.open(

'Selected month finalized successfully.',

'Close',

{ duration: 3000 }

);

this.loadWagesForSelectedMonth();

},

_ => {

this._snackBar.open(

'Error while finalizing selected month.',

'Close',

{ duration: 3000 }

);

}

);

}

exportToCsv(): void {

if (!this.wages || this.wages.length === 0) {

this._snackBar.open('No wage data to export.', 'Close', {

duration: 3000

});

return;

}

const header = Object.keys(this.wages[0]);

const rows = this.wages.map(w => header.map(key => (w as any)[key] ?? ''));

const csvContent =

header.join(',') +

'\n' +

rows.map(r => r.map(value => `"${String(value).replace('"', '""')}"`).join(',')).join('\n');

const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

const link = document.createElement('a');

const url = URL.createObjectURL(blob);

link.href = url;

const fileMonth = this.selectedMonthYear || 'all';

link.download = `wages-${fileMonth}.csv`;

link.click();

URL.revokeObjectURL(url);

}

postRunForSelectedMonth(): void {

if (!this.selectedMonthYear) {

this._snackBar.open('Please select a month first.', 'Close', {

duration: 3000

});

return;

}

this.apiService.getPayrollRuns().subscribe(

data => {

const runs = data && data.runs ? data.runs : [];

const approvedRun = runs.find(

(r: any) => r.monthYear === this.selectedMonthYear && r.status === 'APPROVED'

);

if (!approvedRun) {

this._snackBar.open('No APPROVED payroll run found for selected month.', 'Close', {

duration: 3000

});

return;

}

this.apiService.postPayrollRun(approvedRun.runId).subscribe(

_ => {

this._snackBar.open(

'Payroll run posted to wages for selected month.',

'Close',

{ duration: 3000 }

);

this.loadWagesForSelectedMonth();

},

_ => {

this._snackBar.open(

'Failed to post payroll run for selected month.',

'Close',

{ duration: 3000 }

);

}

);

},

_ => {

this._snackBar.open('Failed to load payroll runs.', 'Close', {

duration: 3000

});

}

);

}

}